import AnketaScreen from './AnketaScreen';

export default AnketaScreen;
